module.exports = __webpack_public_path__ + "img/log.0a0a6048.jpg";